export default {
  data() {
    return {
      menuVisible: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      document.documentElement.classList.toggle('overflow-hidden');
      document.body.classList.toggle('overflow-hidden');
    },
  },
  render() {
    return this.$scopedSlots.default({
      menuVisible: this.menuVisible,
      toggleMenu: this.toggleMenu,
      user: this.user,
    });
  },
  created() {
    this.$store.dispatch('user/GET_USER_DETAILS');
  },
};
